// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3guvM","label":"Category_label__Bcg77","content":"Category_content__1Wh0K","header":"Category_header__3Eawx","location":"Category_location__35t9_"};